import { cn } from '@/lib/tailwind.utils'

interface SectionProps {
  backgroundColor?: string
  id?: string
  children?: React.ReactNode
  rightSideBox?: React.ReactNode
  rightSideImage?: React.ReactNode
  leftSideImage?: React.ReactNode
  className?: string
  contentClassName?: string
}

export const GuideSection = ({
  backgroundColor,
  id,
  children,
  leftSideImage,
  rightSideBox,
  rightSideImage,
  className,
  contentClassName,
}: SectionProps) => {
  return (
    <section
      id={id}
      className={cn('w-full', className)}
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <div className="flex items-start w-full gap-8 px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {leftSideImage && (
          <aside className="hidden shrink-0 lg:block">
            <div className="overflow-hidden border shadow-sm rounded-2xl border-border bg-card">
              {leftSideImage}
            </div>
          </aside>
        )}

        <div className={cn('min-w-0 flex-1', contentClassName)}>{children}</div>

        {rightSideBox && (
          <aside className="hidden w-[320px] shrink-0 xl:block">
            <div className="p-6 border shadow-sm rounded-2xl border-border bg-card">
              {rightSideBox}
            </div>
          </aside>
        )}

        {rightSideImage && (
          <aside className="hidden shrink-0 lg:block">
            <div className="overflow-hidden border shadow-sm rounded-2xl border-border bg-card">
              {rightSideImage}
            </div>
          </aside>
        )}
      </div>
    </section>
  )
}
